/**
 * Keeps the click that ends the current press from reaching what's under the
 * pointer, as long as `shouldConsume` still says so when it lands. For a press
 * outside a dialog that asked about unsaved changes instead of closing: the
 * press opened the question, so its click shouldn't also follow a link or
 * select a cell behind it. Clicks inside a dialog (the question's own buttons)
 * always go through.
 */
export function consumeNextClick(shouldConsume: () => boolean = () => true) {
  const consume = (event: MouseEvent) => {
    if (!shouldConsume()) return
    if (event.target instanceof Element && event.target.closest('[role="dialog"]')) return
    event.preventDefault()
    event.stopPropagation()
  }
  const release = () => {
    document.removeEventListener('click', consume, true)
    document.removeEventListener('mouseup', releaseAfterClick, true)
    document.removeEventListener('mousedown', release, true)
  }
  // The click follows its mouseup in the same task, so it lands before this
  // timeout. A press that ends without one (a drag, a release outside the
  // window) is let go by the next press.
  const releaseAfterClick = () => window.setTimeout(release, 0)
  document.addEventListener('click', consume, true)
  document.addEventListener('mouseup', releaseAfterClick, true)
  document.addEventListener('mousedown', release, true)
}
